import React from 'react';
import PropTypes from 'prop-types';

import { isMobile } from '@mssgme/helpers';
import { __t } from '@mssgme/shared';
import { LanguageContext } from '@mssgme/hooks';
import { Branding } from '@mssgme/ui';
import { MESSENGER_BRANDS, AVAILABLE_MESSENGERS } from './constants';
import SendButton from './SendButton';
import Header from './Header';
import ScanQR from './ScanQR';
import styles from './Redirect.module.scss';

const Pararaph = (props) => <div className={styles.pararaph} {...props} />;

export default class Redirect extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            messenger: PropTypes.oneOf(AVAILABLE_MESSENGERS).isRequired,
            name: PropTypes.string.isRequired,
            appLink: PropTypes.string.isRequired,
            fullname: PropTypes.string.isRequired,
            branding: PropTypes.bool.isRequired,
            qrCode: PropTypes.string,
        }).isRequired,
        lang: PropTypes.string,
    };

    openLink = () => {
        const {
            data: { appLink },
        } = this.props;
        // const isApp = !appLink.match(/^(https?:\/\/.+)/);

        window.location.href = appLink;
    };

    // componentDidMount() {
    //     setTimeout(() => {
    //         this.openLink();
    //     }, 100);
    // }

    render() {
        const {
            data: { messenger, name, qrCode, appLink, branding, fullname },
            lang,
        } = this.props;
        const { label, color } = MESSENGER_BRANDS[messenger];

        return (
            <LanguageContext.Provider value={lang}>
                <div className={styles.root}>
                    <Header messenger={messenger} />
                    <div className={styles.content}>
                        <div>
                            <h1 className={styles.write}>{__t('write_on', [fullname, label])}</h1>
                            <Pararaph>{__t('click_on_button', [label])}</Pararaph>
                            <Pararaph>
                                <SendButton href={appLink} style={{ backgroundColor: color }} />
                            </Pararaph>
                            {!isMobile() && (
                                <Pararaph>
                                    <ScanQR caption={__t('scan_qr')} src={qrCode} />
                                </Pararaph>
                            )}
                            {branding && (
                                <Pararaph>
                                    <Branding className={styles.branding} />
                                </Pararaph>
                            )}
                        </div>
                    </div>
                </div>
            </LanguageContext.Provider>
        );
    }
}
